export default __webpack_public_path__ + "static/media/matrimony11.bae8fb5d.jpg";